<style scoped>
.forget-pass /deep/.el-form-item__label {
  line-height: 60px;
}

/deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #fff;
  background-color: #86b8bc;
  border-color: #86b8bc;
}

/deep/.el-input input:-webkit-autofill {
  background: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
}

/deep/.el-input__inner {
  border: none;
  border: 1px solid #d9d9d9;
  border-radius: 0;
  height: 44px;
  margin-top: 10px;
}


.pass-ruleForm /deep/.el-input__suffix {
  top: 15px !important;
  right: 10px !important;
  cursor: pointer;
}

.bac-img {
  width: 35%;
  height: 100vh;
  background: #4fa1a4;
  position: relative;
}

.bac-img img {
  width: 68%;
  margin-top: 10vh;
  left: 60px;
  border-radius: 10px;
}

.login-box {
  /* padding-top: 4vh; */
  /* padding-bottom: 4vh; */
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
}

.login-right {
  float: right;
  position: relative;
  width: 460px;
  height: 100%;
  padding-top: 20vh;
  padding-bottom: 4vh;
  box-sizing: border-box;
  margin-right: calc(32.5% - 250px);
}

a {
  color: #4fa1a4;
}

/deep/.el-form-item__error {
  left: 15px;
}

.title-txt {
  font-size: 28px;
  margin-top: 30px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.font-line {
  font-size: 26px !important;
  color: rgb(202, 201, 201);
}

.cen-sty {
  /* width: 1000px; */
  margin: 0 auto;
}

.logo-sty-img-big {
  width: 250px;
  /* height: 58px; */
}

.logo-sty-img-box {
  width: 250px;
  height: 58px;
  margin-left: 105px;
}

.login-sty {
  width: 400px;
  height: 200px;
  border-radius: 4px;
  margin-top: 15px;
  margin-left: 40px;
}

.foot-sty {
  font-size: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 30px;
  text-align: center;
}

.left-title {
  color: #fff;
  font-size: 22px;
  text-align: center;
  padding: 0 11%;
  font-weight: 500;
  line-height: 40px;
  margin-top: 8vh;
}

.desc-text {
  font-size: 15px;
  color: #fff;
  padding: 0 16% 0 16%;
  text-align: left;
  line-height: 28px;
}

.label-tip {
  text-align: left;
  padding-left: 15px;
  line-height: 13px;
  color: rgb(156, 156, 156);
}

.el-button+.el-button {
  margin-left: 0;
}

/deep/.el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: rgb(156, 156, 156);
}

/deep/.el-input__inner:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 适配火狐 */
  color: rgb(156, 156, 156);
}

/deep/.el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ 适配火狐 */
  color: rgb(156, 156, 156);
}

/deep/.el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+  适配ie*/
  color: rgb(156, 156, 156);
}

/deep/.el-dialog {
  margin-left: calc(67.5% - 210px);
  border-radius: 8px;
}

.forget-sty {
  font-size: 12px;
  color: #b2b2b2;
  cursor: pointer;
}

.hqyzm {
  border-left: 1px solid #b2b2b2;
  width: 100px;
  height: 22px;
  font-size: 14px;
  line-height: 18px;
  color: #4fa1a4;
  padding-left: 10px;
  position: absolute;
  z-index: 5;
  right: 5px;
  margin-top: -30px;
  cursor: pointer;
  text-align: center;
}

.eye-k-sty {
  position: absolute;
  z-index: 9;
  right: 10px;
  margin-top: 26px;
  cursor: pointer;
}

/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #9d9d9d;
  font-size: 13px;
}

/deep/ .el-checkbox__label {
  color: #9d9d9d;
  font-size: 13px;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4fa1a4;
  border-color: #4fa1a4;
}

.xieyi {
  font-size: 13px;
  margin: 20px 0;
  text-align: left;
}

.more-contain {
  font-size: 12px;
  color: #B2B2B2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.more-contain .line {
  height: 1px;
  width: 150px;
  background: #D9D9D9;

}

.more-contain .txt {
  margin: 0 10px;
}

.pass-ruleForm /deep/ .el-form-item {
  margin-bottom: 15px;
}
</style>
<template>
  <div v-if="!isBindWx" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="cen-sty" v-show="!autoLogin">
      <div class="login-box">
        <div class="bac-img fl">
          <img src="../assets/images/left-pic.png" alt="" />
          <p class="left-title">运营人员的高效处理平台</p>
          <!-- <p class="left-title mt20">提供信息化产品与运营服务</p> -->
          <div class="desc-text">
            <p>
              帮助运营人员做什么？<br />-帮助运营人员辅助药企运营，<br />-支撑运营人员进行企业内部的人事管理、流程管理、报表管理、数据管理等日常工作。
            </p>
          </div>
        </div>
        <div class="login-right">
          <div class="logo-sty-img-box">
            <img class="logo-sty-img-big" src="../assets/images/logo-fbt.png" />
          </div>
          <div class="title-txt">
            <span class="fontC-4fa1a4">FBT运营平台</span>
            <span class="font-line">|</span>
            <span class="fontC-4fa1a4">登录</span>
          </div>

          <div class="login-sty fl">
            <el-form :model="ruleForm" ref="ruleForm" label-width="0" class="demo-ruleForm  pass-ruleForm">
              <el-form-item label="" prop="logonUser">
                <!-- <p class="label-tip" v-if="ruleForm.logonUser !== ''">登录账号</p> -->
                <el-input v-model.trim="ruleForm.logonUser" class="w100f" placeholder="输入账号">
                  <i slot="suffix" v-if="ruleForm.logonUser" @click="ruleForm.logonUser = ''; ruleForm.pwd = ''">
                    <img style="width:15px;" src="../assets/ic_clear.png" alt="" srcset="">
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="pwd">
                <!-- <p class="label-tip" v-if="ruleForm.pwd !== ''">密码</p> -->
                <el-input :type="passw" v-model.trim="ruleForm.pwd" class="w100f" placeholder="输入密码">
                  <i slot="suffix" v-if="passw == 'password' && ruleForm.pwd" @click="passw = 'text'">
                    <img style="width:15px;" src="../assets/close_eye.png" alt="" srcset="">
                  </i>
                  <i slot="suffix" v-if="passw == 'text' && ruleForm.pwd" @click="passw = 'password'">
                    <img style="width:15px;" src="../assets/open_eye.png" alt="" srcset="">
                  </i>
                </el-input>
              </el-form-item>
              <div class="xieyi">
                <el-checkbox v-model="ruleForm.isAgree">我已阅读并同意<span style="color: #4fa1a4"
                    @click.stop.prevent="newOpen(0)">《隐私声明》</span>及<span style="color: #4fa1a4"
                    @click.stop.prevent="newOpen(1)">《用户协议》</span></el-checkbox>
              </div>
              <el-form-item>
                <el-button size="medium" :type="buttonType == 0 ? 'no' : 'info'"
                  style="width: 100%; height: 45px; border-radius: 0px" @click="submitForm('ruleForm')">登录</el-button>
                <div class="forget-sty" @click="forgetPwd">忘记密码</div>
              </el-form-item>
            </el-form>
          </div>
          <!-- <div class="foot-sty">
            <span>COPYRIGHT © 2016-2024</span>
            <a href="https://beian.miit.gov.cn" target="_blank"> 京ICP备2024044205号 </a> 北京传世博润科技有限公司
          </div> -->
        </div>
      </div>
    </div>
    <el-dialog title="找回密码" :visible.sync="dialogFormVisible" width="460px">
      <el-form :model="ruleForm1" ref="ruleForm1" label-width="100px" class="forget-pass demo-ruleForm">
        <el-form-item label="图形验证码:" prop="validateCode">
          <el-input v-model="ruleForm1.validateCode" autocomplete="off" class="w100f" placeholder="请输入图形验证码"></el-input>
          <div class="hqyzm" @click="getPictureCode">
            <img class="w100f" :src="ruleForm1.imgCaptchaBase64" mode=""/>
          </div>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobileNo">
          <el-input v-model="ruleForm1.mobileNo" autocomplete="off" class="w100f" placeholder="请输入绑定的手机号"></el-input>
          <div class="hqyzm" @click="runcode()">{{ btntext }}</div>
        </el-form-item>
        <el-form-item label="验证码:" prop="smsCode">
          <el-input v-model="ruleForm1.smsCode" autocomplete="off" class="w100f" maxlength="20" placeholder="请输入验证码">
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="pwd">
          <el-input v-model="ruleForm1.pwd" :type="password" autocomplete="off" class="w100f" placeholder="8-16位,含大小写字母 数字 符号">
          </el-input>
          <img class="eye-k-sty" width="15" src="../assets/close_eye.png" v-if="password == 'password'"
            @click="shPwd('text')" />
          <img class="eye-k-sty" width="15" src="../assets/open_eye.png" v-if="password == 'text'"
            @click="shPwd('password')" />
        </el-form-item>
        <el-form-item label="确认密码:" prop="pwd2">
          <el-input v-model="ruleForm1.pwd2" :type="password1" autocomplete="off" class="w100f" maxlength="20"
            placeholder="请与新密码填写一致"></el-input>
          <img class="eye-k-sty" width="15" src="../assets/close_eye.png" v-if="password1 == 'password'"
            @click="shPwd1('text')" />
          <img class="eye-k-sty" width="15" src="../assets/open_eye.png" v-if="password1 == 'text'"
            @click="shPwd1('password')" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" class="mr15" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="resetPwd()"
          v-if="ruleForm1.mobileNo != '' && ruleForm1.validateCode != '' && ruleForm1.smsCode != '' && ruleForm1.pwd != '' && ruleForm1.pwd2 != ''">确定
        </el-button>
        <el-button size="medium" type="info" style="background: #c4c4c4; border: 1px solid #c4c4c4"
          v-else>确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import sha1 from "sha1";
import cloneDeep from 'lodash/cloneDeep';
import { decryptText } from "@/api/portrait"
import { ENV } from "@/api/apiRoute"
import { JSEncrypt } from 'jsencrypt';

export default {
  data() {
    //const ENV = location.href.indexOf('https://scm-operation.csyaoly.com') > -1?'pro': location.href.indexOf('https://scm-operation.cs4pl.com') > -1?'pre':'sit'
    return {
      isBindWx: true,
      radio1: '运营端',
      passw: "password",
      codeList: [],
      ruleForm: {
        logonUser: '',
        pwd: '',
        validateCode: 12345,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        appSideGuid: '03cb364e04d894a44cdb94273abffa13',
        userStatusType: 1,
        isAgree: false,
      },
      rules: {
        logonUser: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入账号',
          },
          {
            min: 1,
            max: 20,
            message: '请输入长度在 1-20 个字符',
            trigger: 'blur',
          },
          {
            validator: this.checkData,
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入密码',
          },
          {
            min: 6,
            max: 20,
            message: '请输入长度在 6-20 个字符',
            trigger: 'blur',
          },
          {
            validator: this.checkData,
            trigger: 'blur',
          },
        ],
      },
      fullscreenLoading: false,
      menuList: [],
      btntext: '获取验证码',
      second: 120,
      disabled: false,
      password: 'password',
      password1: 'password',
      dialogFormVisible: false,
      ruleForm1: {
        mobileNo: '',
        smsCode: '',
        pwd: '',
        pwd2: '',
        validateCode: '',
        validateCodeGuid: '',
        imgCaptchaBase64: '',
      },
      autoLogin: false,
      tUrl: ''
    };
  },
  computed: {
    buttonType() {
      if (this.ruleForm.logonUser !== '' && this.ruleForm.pwd !== '' && this.ruleForm.isAgree) {
        return 1;
      } else {
        return 0;
      }
    }
  },
  created() {
    document.title = '登录';

    // // 通过idaas传递的loginInfo登录
    // const loginInfo = localStorage.loginInfo || '';
    // if (loginInfo) {
    //   this.fullscreenLoading = true;
    //   this.autoLogin = true;
    //   // 从资产流通平台打开进入
    //   this.tUrl = 'portraitBMap';
    //   // loginInfo 的加密流程：JSON.stringify → RSA加密 → encodeURI
    //   // 所以解密流程应该是：decodeURI → RSA解密 → JSON.parse
    //   try {
    //     // 第一步：URI 解码
    //     const decodedText = decodeURI(loginInfo);
    //     // 第二步：RSA 解密（将空格替换为 + 号，这是 Base64 标准格式）
    //     const replaceText = decodedText.replace(/\s/g, '+');
    //     let loginText = decryptText(replaceText);
    //     // 第三步：JSON 解析
    //     let loginInfoObj = loginText && JSON.parse(loginText);
    //     if (loginInfoObj?.username) {
    //       this.ruleForm.logonUser = loginInfoObj.username;
    //       this.ruleForm.pwd = loginInfoObj.pwd;
    //       this.ruleForm.isAgree = true;
    //       this.$nextTick(() => {
    //         this.isBindWx = true;
    //         this.submitForm('ruleForm');
    //       });
    //     }
    //   } catch (error) {
    //     console.error('自动登录信息解密失败:', error);
    //     this.$message.error('自动登录失败，请手动登录');
    //   }
    // }
    // if(localStorage.token && localStorage.tUrl){
    //   self.$router.push(localStorage.tUrl);
    //   return;
    // }

    localStorage.clear();
    //自动登录
    if (this.$route.query.token) {
      localStorage.setItem('wynToken', JSON.stringify('670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'));
      localStorage.token = this.$route.query.token;
      this.fullscreenLoading = true;
      this.isBindWx = true;
      this.getLastLogin();
      return;
    }
    this.isBindWx = false;
  },
  methods: {
    async getPictureCode() {
      const { data } =  await this.api.get('/user/get-picture-code')
      this.ruleForm1.validateCodeGuid = data.data.guid;
      this.ruleForm1.imgCaptchaBase64 = data.data.imageBase64;
    },
    newOpen(type) {
      if (type == 1) {
        window.open(window.location.origin + '/userAgree')
      } else {
        window.open(window.location.origin + '/userPrivate')
      }
    },
    shPwd(flg) {
      this.password = flg;
    },
    shPwd1(flg) {
      this.password1 = flg;
    },
    forgetPwd() {
      let self = this;
      self.getPictureCode()
      self.btntext = '获取验证码';
      clearInterval(self.clock);
      self.dialogFormVisible = true;
      self.ruleForm1.validateCode = '';
      self.ruleForm1.mobileNo = '';
      self.ruleForm1.smsCode = '';
      self.ruleForm1.pwd = '';
      self.ruleForm1.pwd2 = '';
      // 延迟一小段时间再次清空密码字段，防止浏览器自动填充
      setTimeout(() => {
        self.ruleForm1.validateCode = '';
        self.ruleForm1.mobileNo = '';
        self.ruleForm1.smsCode = '';
        self.ruleForm1.pwd = '';
        self.ruleForm1.pwd2 = '';
      }, 1000);
    },
    runcode() {
      let self = this;
      if (!self.ruleForm1.validateCode) {
        self.$message.error('请输入图形验证码！');
        return false;
      }
      let testTel = /^1[3456789]\d{9}$/;
      if (!self.ruleForm1.mobileNo || !testTel.test(self.ruleForm1.mobileNo)) {
        self.$message.error('请输入您的正确手机号码！');
        return false;
      }
      if (self.disabled) {
        return false;
      }
      self.api
        .get(
          `/user/send-msg-code?mobileNo=${self.ruleForm1.mobileNo}&logonUser=${self.ruleForm1.mobileNo}&validateCodeGuid=${self.ruleForm1.validateCodeGuid}&validateCode=${self.ruleForm1.validateCode}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('发送验证码成功');
            self.clock = setInterval(self.sendCode, 1000);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    sendCode() {
      let self = this;
      self.second--;
      self.disabled = true;
      self.btntext = self.second + '秒后可获取';
      if (self.second == 0) {
        clearInterval(self.clock);
        self.second = 120;
        self.btntext = '获取验证码';
        self.disabled = false;
      }
    },
    findFirstUnmetRequirement(password, checks) {
      if (!password) return "请输入密码";
      const requirements = [
        { key: 'length', label: '密码长度必须为8-16位' },
        { key: 'lower', label: '必须包含小写字母 (a-z)' },
        { key: 'upper', label: '必须包含大写字母 (A-Z)' },
        { key: 'number', label: '必须包含数字 (0-9)' },
        { key: 'special', label: '必须包含特殊符号' }
      ];
      for (const requirement of requirements) {
        if (!checks[requirement.key]) {
          return requirement.label;
        }
      }
      return null; // 全部满足
    },
    checkPassword(pwd) {
      if (!pwd) return { score: 0, level: "invalid", checks: {}, isValid: false };
      const checks = {
        length: pwd.length >= 8 && pwd.length <= 16,
        lower: /[a-z]/.test(pwd), // 包含小写字母
        upper: /[A-Z]/.test(pwd), // 包含大写字母
        number: /[0-9]/.test(pwd), // 包含数字
        special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd), // 包含特殊符号
      };

      const score = Object.values(checks).filter(Boolean).length;
      const isValid = Object.values(checks).every(Boolean); // 所有检查都必须通过

      let level = "weak";
      if (isValid) level = "strong";
      else if (score >= 2) level = "medium";

      const firstUnmet = this.findFirstUnmetRequirement(pwd, checks);

      return { score, level, checks, firstUnmet, isValid };
    },
    async resetPwd() {
      let self = this;
      let testTel = /^1[345789]\d{9}$/;
      if (!self.ruleForm1.mobileNo || !testTel.test(self.ruleForm1.mobileNo)) {
        self.$message.error('请输入您的正确手机号码！');
        return;
      }
      if (self.ruleForm1.pwd == '') {
        self.$message.error('请输入密码！');
        return false;
      }
      if (self.ruleForm1.pwd !== self.ruleForm1.pwd2) {
        self.$message.error('两次密码请填写一样！');
        return false;
      }
      const f = self.checkPassword(self.ruleForm1.pwd2)
      if (!f.isValid) {
        self.$message.error(`密码不符合要求，请修改密码！${f.firstUnmet}`);
        return;
      }
      let query = {
        mobileNo: self.ruleForm1.mobileNo,
        pwd: self.$md5(self.ruleForm1.pwd),
        // pwd2: self.$md5(self.ruleForm1.pwd2),
        smsCode: self.ruleForm1.smsCode,
        logonUser: self.ruleForm1.mobileNo,
      };
      self.api
        .put(`/${serverConfig.msCommonAdminPlatformAuthService}/user/data/resetPwd-byMsgCode`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('密码修改成功，请重新登录');
            self.dialogFormVisible = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //验证数字
    checkNumber(rule, value, callback) {
      if (value) {
        if (/[^\d]/g.test(value)) {
          callback(new Error('请输入纯数字!'));
        } else {
          callback();
        }
      }
      callback();
    },
    //验证字符
    checkData(rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('请输入字符!'));
        } else {
          callback();
        }
      }
      callback();
    },
    // 排序
    getSort(ruleForm) {
      let arr = [];
      let sum = 0;
      let parame = '';
      for (let r in ruleForm) {
        sum++
        arr.push(r + ruleForm[r]);
      }
      arr = arr.sort();
      if (sum == arr.length) {
        arr.forEach((i) => {
          parame = parame + i;

        })
      }
      // console.log(parame);
      return parame;
    },
    async submitForm(formName) {
      let self = this;
      let pwd = '';
      if (self.ruleForm.pwd) {
        pwd = self.$md5(self.ruleForm.pwd);
      }
      if (!this.ruleForm.isAgree) return;
      const query = {
        logonUser: self.ruleForm.logonUser,
      };
      const { data } = await self.api.get(
        `/${serverConfig.msCommonAdminPlatformAuthService}/user/get-pwd-state`,
        query
      );
      if (data.code !== serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(data.msg);
        return;
      }
      const params = {
        username: self.ruleForm.logonUser,
        password: self.$md5(self.ruleForm.pwd),
      }
      // 需要两层加密
      if (data.data == 2) {
        params.password = self.$md5(self.$md5(self.ruleForm.pwd) + "csbr#pwd");
      }
      // idass 登录
      const res = await self.api.post('/oauth/login',params)
      if (res.data.code !== serverConfig.REQUIRE_SUCCESS_CODE) {
        self.$message.error(res.data.msg);
        return
      }
      // // 跳转tUrl
      // if(self.tUrl){
      //   localStorage.tUrl = '/'+self.tUrl;
      //   self.$router.push('/LoginIDaaS');
      // }

      // 固定参数
      const state = "02373123123418391";
      const scope = "other";
      const response_type = "code";
      let redirect_uri = "http://localhost:9001/LoginIDaaS"; // 本地
      let client_id = "69648538e4b0c6ac84adcc52" // 测试id
      if (ENV === 'pro' || ENV === 'pre') {
        client_id = "699eba3de4b0ede30d15a072"
        // redirect_uri = "https://scm-operation.csyaoly.com/LoginIDaaS" // 生产
      }
      if (ENV === 'sit') {
        client_id = "69648538e4b0c6ac84adcc52"
        // redirect_uri = "https://scm-operation-test.csbr.cn/LoginIDaaS"; // 测试环境
      }
      if (ENV === 'uat') {
        client_id = "69648538e4b0c6ac84adcc52"
        // redirect_uri = "https://scm-operation-pre-test.cs4pl.com/LoginIDaaS"; // uat环境
      }
      redirect_uri = window.location.origin + "/LoginIDaaS";
      redirect_uri = encodeURIComponent(redirect_uri);
      console.log('ENV', ENV);
      const authUrl = `/idaas/oauth2/authorize?response_type=${response_type}&client_id=${client_id}&scope=${scope}&state=${state}&redirect_uri=${redirect_uri}`;
      window.location.href = authUrl;
      return
      let ruleFormNew = {
        logonUser: self.ruleForm.logonUser,
        pwd: self.$md5(self.ruleForm.pwd),
        platformGuid: self.ruleForm.platformGuid,
        appSideGuid: self.ruleForm.appSideGuid,
        userStatusType: self.ruleForm.userStatusType
      };
      let par = self.getSort(ruleFormNew);
      let time = Date.parse(new Date());
      let parame = 'FBT@CsBR_943Rsve30fFFBPoi0o0o0' + par + 'FBT@CsBR_943Rsve30fFFBPoi0o0o0';
      let sign = sha1(parame).toUpperCase();
      if (!this.ruleForm.isAgree) return;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.api
            .postSign(
              '/csbr-zuul/user/login?' +
              `logonUser=` +
              self.ruleForm.logonUser +
              `&platformGuid=` +
              self.ruleForm.platformGuid +
              `&pwd=` +
              pwd +
              `&appSideGuid=` +
              self.ruleForm.appSideGuid +
              `&userStatusType=` +
              self.ruleForm.userStatusType +
              `&validateCode=` +
              self.ruleForm.validateCode, { 'sign': sign, 'timeStamp': time / 1000 }
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                // window.sessionStorage.setItem('token',res.data.data.token);
                localStorage.setItem(
                  'wynToken',
                  JSON.stringify('670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'),
                );
                localStorage.token = res.data.data.token;
                self.getLastLogin();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          self.$message.error('登录失败！');
          return false;
        }
      });
    },
    getLastLogin() {
      let self = this;
      self.api.get(`/${serverConfig.msCommonAdminPlatformAuthService}/user/get-latest-login-info`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.currentTenantGuid = res.data.data.latestLoginTenantGuid;
          this.getCurrentuser(res.data.data.latestLoginTenantGuid);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getCurrentuser(latestLoginTenantGuid) {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`).then(async (res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // console.log(res.data.data);
          if (res.data.data != null && res.data.data != '') {
            self.$store.commit('$_setTenantGuid', latestLoginTenantGuid || res.data.data[0].guid);
            self.getAddRedis(latestLoginTenantGuid || res.data.data[0].guid);
            await self.getCodeList();
            if (!self.codeList.length) {
              await self.$confirm(
                "未能成功获取字典数据，请联系技术人员!",
                "提示",
                {
                  confirmButtonText: "确定",
                  showCancelButton: false,
                  type: "warning",
                }
              );
            }
            self.getCurrentstaff(latestLoginTenantGuid || res.data.data[0].guid);
            localStorage.supertubeFlag = res.data.data[0].supertubeFlag
          } else {
            self.$message.error('当前人员未备案到药企，请联系运营人员!');
            return
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getCurrentstaff(tenantGuid) {
      let self = this;
      self.api
        .get(`/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.data));
            self.ruleForm.userGuid = res.data.data.userGuid;
            self.getMenuList(tenantGuid)
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getMenuList(tenantGuid) {
      let self = this;
      let appSideGuid = self.ruleForm.appSideGuid;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
          `appType=01&tenantGuid=` +
          tenantGuid +
          `&appSideIdentifier=scm_operative`,
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('登录成功');
            self.menuList = res.data.data;
            self.menuList.forEach(function (i, idx) {
              if (i.externalLinkMark == '01') {
                i.src = i.path;
                i.path = '/reportQueryList-' + idx;
                // console.log('1', i.externalLinkMark);
                if (i.children != null && i.children != '') {
                  i.children.forEach(function (j, index) {
                    index = index + 1;
                    if (j.externalLinkMark == '01') {
                      // console.log('11', j.externalLinkMark);
                      j.src = j.path;
                      j.path = '/reportQuery-' + idx + index;
                    }
                  });
                }
              }
            });
            localStorage.setItem('appSideGuid', JSON.stringify(appSideGuid));
            localStorage.setItem('allMenuList', JSON.stringify(cloneDeep(res.data.data)));
            if (res.data.data[0].menuName == '主页') {
              //判断工作台首页
              if (res.data.data[0].path == '/SZ_homePageReportNew' && res.data.data[0].children) {
                localStorage.setItem('reportMenuList', JSON.stringify(res.data.data[0].children));
              }
              //有个人首页，导航不显示个人主页菜单，直接跳转
              self.menuList = self.menuList.slice(1);
              localStorage.setItem('menuList', JSON.stringify(self.menuList));
              self.$router.replace({ path: res.data.data[0].path, query: { pageMenuGuid: res.data.data[0].guid } });
            } else {
              localStorage.setItem('menuList', JSON.stringify(self.menuList));
              if (res.data.data[0].children != null && res.data.data[0].children.length > 0) {
                setTimeout(function () {
                  self.$router.replace(res.data.data[0].children[0].path);
                }, 500);
              } else {
                self.$router.push('/reportQueryList-0');
              }
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAddRedis(tenantGuid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/data/add-currentstaff-to-redis?tenantGuid=${tenantGuid}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async getCodeList() {
      let that = this;
      await that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-all`).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          localStorage.codeList = JSON.stringify(resp.data.data)
          this.codeList = resp.data.data
        } else {
          that.$message.error(resp.data.msg);
        }
      });
    },
  },
};
</script>
